import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './coreui-visual.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { prepareInitialAuthRoute } from './authProvider';

prepareInitialAuthRoute();

const initialTheme = localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';
document.body.classList.add(`theme-${initialTheme}`);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
